import { render, staticRenderFns } from "./2c2pErrorPageView.vue?vue&type=template&id=b37c4b5c&"
import script from "./2c2pErrorPageView.vue?vue&type=script&lang=js&"
export * from "./2c2pErrorPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports